import { render } from "./WildBookObserveSpecData.vue?vue&type=template&id=9bb0dd48&scoped=true&ts=true"
import script from "./WildBookObserveSpecData.vue?vue&type=script&lang=ts"
export * from "./WildBookObserveSpecData.vue?vue&type=script&lang=ts"

import "./WildBookObserveSpecData.vue?vue&type=style&index=0&id=9bb0dd48&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb0dd48"]])

export default __exports__